;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="73fda16c-050b-46ed-859c-ecef2a9916bc",e._sentryDebugIdIdentifier="sentry-dbid-73fda16c-050b-46ed-859c-ecef2a9916bc")}catch(e){}}();import classNames from '../../node_modules/.pnpm/classnames@2.5.1/node_modules/classnames/index.js';
import React__default, { useContext, useState } from 'react';
import 'react/jsx-runtime';
import ArrowAngleDown from '../../node_modules/.pnpm/@zooplus_icons@2.3.0_react-dom@18.3.1_react@18.3.1/node_modules/@zooplus/icons/dist/es/components/ArrowAngleDown.js';
import { LayoutContainer } from '@zooplus/ui-components';
import AppContext from '../../context/AppContext.js';
import '../../_virtual/_sentry-release-injection-file.js';
import CategoryFlyout from '../CategoryFlyout/CategoryFlyout.js';
import { DarkOverlay } from '../DarkOverlay/DarkOverlay.js';
import { ThemedIcon } from '../Icon/Icon.js';
import styles from './LowerBar.module.scss.js';

const ENTER_DELAY = 150;
const LEAVE_DELAY = 300;
function LowerMenu() {
    const { categories, showCategories, translations } = useContext(AppContext);
    const accessibleLabel = translations.get('shop.header.main.navigation.category.accessible.button.label');
    let onCategoryMouseEnterTimeoutID = null;
    let onCategoryMouseLeaveTimeoutID = null;
    const [flyoutsMap, setFlyoutsMap] = useState(new Map(categories.map((_category, index) => [
        index,
        {
            node: React__default.createRef(),
            menu: React__default.createRef(),
            show: false,
        },
    ])));
    const showOverlay = !!Array.from(flyoutsMap.values()).find((value) => value.show === true);
    const onCategoryItemMouseEnter = (index, callback = () => { }) => {
        if (onCategoryMouseLeaveTimeoutID !== null) {
            clearTimeout(onCategoryMouseLeaveTimeoutID);
        }
        onCategoryMouseEnterTimeoutID = setTimeout(() => {
            const entries = categories.map((_category, i) => [
                i,
                {
                    node: React__default.createRef(),
                    menu: React__default.createRef(),
                    show: index === i,
                },
            ]);
            setFlyoutsMap(new Map(entries));
            callback();
        }, ENTER_DELAY);
    };
    const onCategoryFlyoutMouseEnter = () => {
        if (onCategoryMouseLeaveTimeoutID !== null) {
            clearTimeout(onCategoryMouseLeaveTimeoutID);
        }
    };
    const onCategoryMouseLeave = () => {
        if (onCategoryMouseEnterTimeoutID !== null) {
            clearTimeout(onCategoryMouseEnterTimeoutID);
        }
        onCategoryMouseLeaveTimeoutID = setTimeout(() => {
            const entries = categories.map((_category, i) => [
                i,
                {
                    node: React__default.createRef(),
                    menu: React__default.createRef(),
                    show: false,
                },
            ]);
            setFlyoutsMap(new Map(entries));
        }, LEAVE_DELAY);
    };
    const onAccessibleButtonClick = (index) => {
        onCategoryItemMouseEnter(index, () => {
            const flyoutItem = flyoutsMap.get(index);
            if (!flyoutItem)
                return;
            const { node } = flyoutItem;
            if (node.current) {
                const link = node.current.querySelector('a');
                if (link)
                    link.focus();
            }
        });
    };
    const hideAllFlyouts = (callback = () => { }) => {
        const entries = categories.map((_category, i) => [
            i,
            {
                node: React__default.createRef(),
                menu: React__default.createRef(),
                show: false,
            },
        ]);
        setFlyoutsMap(new Map(entries));
        callback();
    };
    const hideAllFlyoutsAndFocus = (index = 0, target = 'a') => {
        // eslint-disable-next-line consistent-return
        hideAllFlyouts(() => {
            const flyoutItem = flyoutsMap.get(index);
            if (!flyoutItem)
                return null;
            const { menu } = flyoutItem;
            if (menu.current) {
                const link = menu.current.querySelector(target);
                if (link)
                    link.focus();
            }
        });
    };
    if (!showCategories) {
        return (React__default.createElement("div", { "data-zta": "lower-bar-empty", className: styles.desktopEmptyNav }));
    }
    return (React__default.createElement("nav", null,
        React__default.createElement(LayoutContainer, { variant: "default", className: styles.desktopNavigation, "data-zta": "lower-bar", id: "header-category-links", "aria-label": translations.get('shop.header.main.navigation.title') },
            React__default.createElement("div", { "data-zta": "lower-bar-category-slider", className: styles.categorySlider },
                React__default.createElement("ul", { className: styles.categoryBar, "data-zta": "lower-bar-categories" }, categories.map((category, index) => {
                    const flyoutItem = flyoutsMap.get(index);
                    if (!flyoutItem)
                        return null;
                    const { title, path } = category;
                    const { show, menu } = flyoutItem;
                    return (React__default.createElement("li", { className: styles.categoryItem, "data-zta": "lower-bar-category-item", key: title, ref: menu, onMouseEnter: () => onCategoryItemMouseEnter(index), onMouseLeave: onCategoryMouseLeave },
                        React__default.createElement("a", { className: classNames(styles.categoryItemLink, {
                                [styles.categoryItemLinkActive]: category.active,
                            }), "data-zta": "lower-bar-category-item-link", href: path }, title),
                        React__default.createElement("button", { "aria-expanded": show, "aria-labelledby": `category-button-label-${title}`, className: styles.categoryItemButton, "data-zta": "lower-bar-category-item-btn", onClick: () => onAccessibleButtonClick(index), type: "button" },
                            React__default.createElement(ThemedIcon, { Icon: ArrowAngleDown, width: "18", height: "18", viewBox: "3 3 18 18", "aria-labelledby": `category-button-label-${title}`, color: 'neutralDark' }),
                            React__default.createElement("div", { className: styles.accessibleText, id: `category-button-label-${title}` }, `${accessibleLabel}: ${title}`))));
                }))),
            categories.map((category, index) => {
                const { node, show } = flyoutsMap.get(index);
                const onBlurFirst = () => {
                    hideAllFlyoutsAndFocus(index, 'button');
                };
                const onBlurLast = () => {
                    const isLastFlyout = index === flyoutsMap.size - 1;
                    if (!isLastFlyout) {
                        hideAllFlyoutsAndFocus(index + 1, 'a');
                    }
                    else {
                        hideAllFlyouts();
                    }
                };
                return (React__default.createElement(CategoryFlyout, { key: category.title, ref: node, show: show, category: category, onMouseEnter: onCategoryFlyoutMouseEnter, onMouseLeave: onCategoryMouseLeave, onBlurFirst: onBlurFirst, onBlurLast: onBlurLast }));
            }),
            React__default.createElement(DarkOverlay, { show: showOverlay }))));
}

export { ENTER_DELAY, LEAVE_DELAY, LowerMenu as default };
//# sourceMappingURL=LowerBar.js.map
